// automatically generated by the FlatBuffers compiler, do not modify

export enum IntervalUnit {
  YEAR_MONTH = 0,
  DAY_TIME = 1,
  MONTH_DAY_NANO = 2
}
